import { Alert, Box, CircularProgress, Paper, TextField, Typography } from "@mui/material";
import Logger from "../../../services/Logger";
import * as React from "react";
import { useEffect, useState } from "react";
import WordNetworkPanel from "../../../pages/components/puzzle/WordNetworkPanel";
import ApiService from "../../../services/ApiService";

const WordNetworkMain = () => {
    const [graphData, setGraphData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [, setMetadata] = useState(null);
    const [templateId, setTemplateId] = useState("cdb497b2-2ed7-457a-8187-e81a8d0b078c");

    const fetchGraphData = async () => {
        setLoading(true);
        setError(null);
        setGraphData(null);
        setMetadata(null);

        try {
            const result = await ApiService.getData(
                `/test/${templateId}/word-network`
            );

            if (result && result.nodes && result.links) {
                setGraphData(result);
                if (result.metadata) {
                    setMetadata(result.metadata);
                }
            } else {
                setError("Invalid graph data format received");
            }
        } catch (err) {
            Logger.error("Graph API Error:", err);
            setError(`Failed to fetch graph data: ${err.message || "Unknown error"}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGraphData();
    }, [templateId]);

    return (
        <Box sx={{ maxWidth: "lg", mx: "auto", mt: 4, mb: 4, px: 3 }}>
            <Box sx={{ mb: 3 }}>
                <TextField
                    label="Template ID"
                    value={templateId}
                    onChange={(e) => setTemplateId(e.target.value)}
                    size="small"
                    sx={{ width: 400, mb: 2 }}
                />
            </Box>

            <Typography variant="h4" component="h1" gutterBottom>
                Word Network
            </Typography>

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
                    <CircularProgress />
                </Box>
            )}

            {graphData && !loading && (
                <Paper sx={{ p: 3, mt: 2 }}>
                    <Box sx={{ height: "600px" }}>
                        <WordNetworkPanel wordNetwork={graphData} showWordMeaning={false} />
                    </Box>
                </Paper>
            )}
        </Box>
    );
};

export default WordNetworkMain;

